import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { activityStore } from '../stores/ActivityStore';
const ActivityDialog = observer(() => {
    const [formData, setFormData] = useState({
        name: ''
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (activityStore.isEditing && activityStore.selectedActivity) {
            setFormData({
                name: activityStore.selectedActivity.name
            });
        }
        else {
            setFormData({
                name: ''
            });
        }
        setErrors({});
    }, [activityStore.isDialogOpen, activityStore.isEditing, activityStore.selectedActivity]);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = 'Activity name is required';
        }
        else if (formData.name.trim().length < 2) {
            newErrors.name = 'Activity name must be at least 2 characters long';
        }
        else if (formData.name.trim().length > 100) {
            newErrors.name = 'Activity name cannot exceed 100 characters';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        try {
            if (activityStore.isEditing && activityStore.selectedActivity) {
                await activityStore.updateActivity(activityStore.selectedActivity.id, formData);
            }
            else {
                await activityStore.createActivity(formData);
            }
            activityStore.closeDialog();
        }
        catch (error) {
            // Error is handled by the store
        }
    };
    const handleClose = () => {
        activityStore.closeDialog();
    };
    return (_jsxs(Modal, { show: activityStore.isDialogOpen, onHide: handleClose, size: "lg", children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: activityStore.isEditing ? 'Edit Activity' : 'Add New Activity' }) }), _jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs(Modal.Body, { children: [activityStore.hasError && (_jsx(Alert, { variant: "danger", className: "mb-3", children: activityStore.error })), _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Activity Name *" }), _jsx(Form.Control, { type: "text", name: "name", value: formData.name, onChange: handleInputChange, isInvalid: !!errors.name, placeholder: "Enter activity name", disabled: activityStore.isLoading }), _jsx(Form.Control.Feedback, { type: "invalid", children: errors.name })] })] }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: "secondary", onClick: handleClose, disabled: activityStore.isLoading, className: "btn-touch w-mobile-100", children: "Cancel" }), _jsxs(Button, { variant: "primary", type: "submit", disabled: activityStore.isLoading, className: "btn-touch w-mobile-100", children: [activityStore.isLoading && (_jsx(Spinner, { animation: "border", size: "sm", className: "me-2" })), activityStore.isEditing ? 'Update' : 'Create'] })] })] })] }));
});
export default ActivityDialog;
